import { combineReducers } from 'redux';
import renewalReducers from "./renewal";
import travelReducers from './travel';


export default combineReducers({ 
    renewal:renewalReducers,
    travel:travelReducers
});